import utils from '../utils'
import moment from 'moment'
import { createInvoiceSummaryByPayer, addItemInfo, addMobileInfo } from './common'

export function createKBankMCLTxt(invoices) {
  const summaryByPayer = createInvoiceSummaryByPayer(invoices)
  let data = ''
  let seqNo = 1

  for (let summary of summaryByPayer) {
    data += addPayerInfo(summary)
    for (let vendor of summary.vendors) {
      data += addVendorInfo(vendor)
      for (let inv of vendor.invoices) {
        data += addItemInfo(inv, seqNo)
        seqNo++
      }
      data += addMobileInfo(vendor)
    }
  }

  return data
}

function addPayerInfo (summary) {
  let data = ''
  /*
  ลำดับ	ชื่อ Field ธนาคาร	ความหมาย	จำนวน Characters

  ---- LINE 1 ----
  1	H	ข้อมูล Company ระบุค่า H	1
  2	MCL	ช่องทางการจ่ายชำระที่ทางธนาคารกำหนด	3
  3	Debit Account	หมายเลขบัญชีตัดเงิน	10
  4	Batch Ref	หมายเลขอ้างอิงแบตที่ทำรายการ	16
  5	Effective Date	วันที่รายการมีผล	10
  6	 Spacebar	ช่องว่าง	5
  7	Total Credit Item	จำนวนรายการรวมทั้งหมดของการจ่าย	18
  8	Total Debit Amount	จำนวนเงินรวมทั้งหมดของการจ่าย	18
  9	Bank Fee Charge	การเรียกเก็บค่าธรรมเนียม	1
  10	Enter	จบข้อมูลในบรรทัด	
  */
  data += 'H'
  data += 'MCL'
  data += utils.padNumber(summary.payerBankAccount, 10), // Debit Account
  data += utils.padNumber('', 16), // Batch Ref
  // TODO: require user input
  // use current date as default
  data += utils.padText(moment().tz("Asia/Bangkok").format("DD-MM-YYYY"), 10) // Effective Date
  data += utils.space(5)
  data += utils.padNumber(summary.vendors.length, 18), // Total Credit Item / calc
  data += utils.padNumber(summary.invoiceTotalNetAmount, 18), // Total Debit Amount / calc
  // TODO: require user input
  data += 'N'
  data += '\n'

  return data
}

function addVendorInfo (summary) {
  let data = ''
  /*
  ---- LINE 2 ----
  1	D		1
  2	ลำดับ Vendor		6
  3	 Spacebar	ช่องว่าง	4
  4	Amount	จำนวนเงินที่โอน	13
  5	Vendor Name	ชื่อคู่ค้า	80
  6	 Spacebar	ช่องว่าง	30
  7	Vendor Address 1	ที่อยู่คู่ค้า	30
  8	Vendor Address 2	ที่อยู่คู่ค้า	30
  9	Vendor Address 3	ที่อยู่คู่ค้า	30
  10	Vendor Address 4	ที่อยู่คู่ค้า	30
  11	Account Number	เลขที่บัญชีคู่ค้า	20
  12	Bene Ref	หมายเลขอ้างอิง Vendor	16
  13	Personal ID/Tax ID	เลขประจำตัวผูเสียภาษี/เลขประจำตัวบัตรประชาชน	13
  14	Bank Branch Code	สาขาธนาคาร	4
  15	Credit Bank Code	เลขที่บัญชีธนาคารคู่ค้า	3
  16	Payment Detail	รายละเอียดการจ่ายชำระ	255
  17	Spacebar	ช่องว่าง	61
  18	Fax / Email		1
  19	Advice Fax 	เบอร์ Fax คู่ค้า (จำเป็นต้องใส่กรณีที่มี Credit Advice ผ่านทาง Fax)	9
  20	Spacebar	ช่องว่าง	41
  21	AdviceEmail	Email คู่ค้า (จำเป็นต้องใส่กรณีที่มี Credit Advice ผ่านทาง Email)	50
  22	Tax Amt Bef VAT	จำนวนเงินก่อนคิดภาษีมูลค่าเพิ่ม	13
  23	Tax Deducted	จำนวนเงินภาษีหัก ณ ที่จ่าย	13
  24	จำนวน Rate e-WHT ต่อ Vendor	3
  Y2 : 002
  Y3 : 003"	3
  25	Enter	จบข้อมูลในบรรทัด	
  */
  data += 'D'
  data += utils.padNumber(summary.no, 6) // ลำดับ Vendor
  data += utils.space(4)
  data += utils.padDecimal(summary.invoiceTotalNetAmount, 13) // Amount / calc
  data += utils.padText(summary.payeeName, 80) // Vendor Name
  data += utils.space(30)
  // TODO: split address to 4 lines
  data += utils.padText(summary.payeeAddress, 120) // Vendor Address 1-4 (30 each)
  data += utils.padNumber(summary.payeeBankAccount, 20) // Account Number
  data += utils.padText(summary.payeeReference, 16) // Bene Ref
  data += utils.padText(summary.payeeTaxID, 13) // Personal ID/Tax ID
  data += utils.padNumber(summary.payeeBankBranchCode, 4) // Bank Branch Code
  data += utils.padNumber(summary.payeeBankCode, 3) // Credit Bank Code
  // TODO: require user input
  data += utils.padText('Payment detail', 255) // Payment Detail
  data += utils.space(61)
  // TODO: require user input
  data += utils.padText('E', 1) // F (Fax) or E (Email), Optional
  data += utils.padNumber(summary.payeeFax, 9) // Advice Fax
  data += utils.space(41)
  data += utils.padText(summary.payeeEmail, 50) // Advice Email
  data += utils.padDecimal(summary.invoiceBaseAmount, 13) // sum of invoiceBaseAmount
  data += utils.padDecimal(summary.whtAmount, 13) // sum of whtAmount
  data += utils.padNumber(summary.eWhtRateCount, 3) // จำนวน Rate e-WHT ต่อ Vendor ???
  data += '\n'

  return data
}

export default {
  createKBankMCLTxt
}